export default "__VITE_ASSET__DiEA4czv__"